import { render } from "./TextWithLeadingIcon.vue?vue&type=template&id=dac8fe48&scoped=true&ts=true"
import script from "./TextWithLeadingIcon.vue?vue&type=script&lang=ts"
export * from "./TextWithLeadingIcon.vue?vue&type=script&lang=ts"

import "./TextWithLeadingIcon.vue?vue&type=style&index=0&id=dac8fe48&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac8fe48"]])

export default __exports__